import axios from '@/libs/api.request.js'

export default {
    // 下单
    submitOrder: (data) => {
        return axios.request({
            url: 'order/submitOrder',
            data,
            method: 'post'
        })
    },
    // 订单状态
    hasPaid: (params) => {
        return axios.request({
            url: 'order/hasPaid',
            params,
            method: 'get'
        })
    },
    // 订单列表
    orderList: () => {
        return axios.request({
            url: 'order/orderList',
            method: 'post'
        })
    }
}